import SideMenuDrill from './DrillView';
import Link from './Link';
import SubMenu from './SubMenu';
import Navigation from '../core/navigation';

SideMenuDrill.Link = Link;
SideMenuDrill.SubMenu = SubMenu;
SideMenuDrill.Navigation = Navigation;

export default SideMenuDrill;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/DrillView/index.js